import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce8eb03e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "btns-wrapper" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "section-title" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-title" }, " 계정 삭제 안내 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 회원 탈퇴를 신청하기 전에 안내 사항을 꼭 확인해주세요. ", -1))
const _hoisted_9 = { class: "text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("div", null, "탈퇴 후 아래 개인 정보는 즉시 삭제됩니다."),
  /*#__PURE__*/_createElementVNode("div", null, "단, 회원 탈퇴 신청 시 진행 중인 캠페인 수거 신청 이력이 있을 경우, 수거 신청 취소 후 회원 탈퇴 진행을 부탁 드립니다."),
  /*#__PURE__*/_createElementVNode("div", null, "수거 신청 취소가 비활성화된 경우 고객센터 문의를 통해 처리 가능합니다.")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 탈퇴 후 삭제 되는 정보 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text padding-left" }, [
  /*#__PURE__*/_createElementVNode("div", null, "1) 이름"),
  /*#__PURE__*/_createElementVNode("div", null, "2) 이메일"),
  /*#__PURE__*/_createElementVNode("div", null, "3) 연락처"),
  /*#__PURE__*/_createElementVNode("div", null, "4) 주소")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 탈퇴 후에도 남게 되는 정보; 송장번호와 무게 등 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text padding-left" }, [
  /*#__PURE__*/_createElementVNode("div", null, "1) 캠페인 참여 기록"),
  /*#__PURE__*/_createElementVNode("div", null, "2) 수거 신청 기록")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("div", null, "아래 버튼을 누르면 계정이 삭제되어 복구할 수 없게 됩니다."),
  /*#__PURE__*/_createElementVNode("div", { class: "primary-color" }, " 이후 다른 계정을 만들 때 같은 이메일 주소로 재가입이 가능합니다. ")
], -1))
const _hoisted_16 = { class: "btns-wrapper" }

import { onMounted, reactive, ref } from 'vue';
  import { ColorVariants } from '@/constants';
  import { useRouter } from 'vue-router';
  import { authStore } from '@/stores';
  import { FormItem } from '@/types/form';
  import { useI18n } from 'vue-i18n';
  import _ from 'lodash';
  import { getCountryCodeByPhoneNumber } from '@/components/country-selector/countries';
  import { alert, request, getQuestions, getAnswers } from '@/utils';
  import { useToast } from 'bootstrap-vue-3';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const type = ref('password');
  const router = useRouter();
  const answerFormItems = reactive<FormItem[]>([]);
  const answerForm = reactive<{ [key: string]: any }>({});
  let answerFormId: number;
  const verificationForm = reactive<{ [key: string]: any }>({});
  const toast = useToast();

  function formItemChange(data: any) {
    answerForm[data.key] = data.value;
  }

  function verificationFormItemChange(data: any) {
    verificationForm[data.key] = data.value;
  }

  async function handleSubmitAnswer() {
    const answers = {};
    answerFormItems.map(item => {
      answers[item.key] = answerForm[item.keyForSpecifySurvey as string];
    });
    await authStore.delete({
      survey_id: answerFormId,
      type: 'SpecifyResponse',
      answers_attributes: getAnswers(answers, answerFormItems)
    });
    toast.show({ title: t('Success'), body: t('Success') }, { variant: 'success' });
    router.replace({ name: 'home' });
  }

  async function handleVerificationFormSubmit() {
    await request.post('mine/verify_user_account', { ...verificationForm, phone_number: _.get(authStore.user, 'profile.phone_number') });
    type.value = 'answer';
  }

  async function fetchSurvey() {
    const { data } = await request.get('surveys/destroy_account');
    answerFormId = data.id;
    answerFormItems.splice(0, answerFormItems.length - 1, ...getQuestions(data));
  }

  onMounted(async () => {
    await Promise.all([
      authStore.tryFetchData(),
      fetchSurvey(),
    ]);
    if (!authStore.phoneNumber) {
      await alert({ title: t('Please add your phone number first'), btnText: t('Confirm') });
      router.replace({ name: 'mine.memberProfile.edit' });
      return;
    }
    Object.assign(verificationForm, {
      phone_number: authStore.phoneNumber,
      email: _.get(authStore.user, 'profile.email')
    });
  });

return (_ctx: any,_cache: any) => {
  const _component_AppCountrySelector = _resolveComponent("AppCountrySelector")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_AppVerificationCodeBtn = _resolveComponent("AppVerificationCodeBtn")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (type.value === 'password')
    ? (_openBlock(), _createBlock(_component_b_form, {
        key: 0,
        class: "form-wrapper",
        onSubmit: handleVerificationFormSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(t)('Delete Terracycle Account')), 1),
            _createVNode(_component_AppFormGroupItem, {
              config: {
          label: _unref(t)('PHONE NUMBER FORM LABEL'),
          type: 'input',
          key: 'phone_number',
          readonly: true,
        },
              form: _unref(verificationForm)
            }, {
              inputBefore: _withCtx(() => [
                _createVNode(_component_AppCountrySelector, {
                  "country-code": _unref(getCountryCodeByPhoneNumber)(_ctx.$get(_unref(authStore).user, 'profile.phone_number')),
                  disabled: ""
                }, null, 8, ["country-code"])
              ]),
              _: 1
            }, 8, ["config", "form"]),
            _createVNode(_component_AppFormGroupItem, {
              config: {
          label: _unref(t)('VERIFICATION CODE'),
          type: 'input',
          key: 'verification_code',
          required: true,
          placeholder: ''
        },
              form: _unref(verificationForm),
              onChange: verificationFormItemChange
            }, {
              inputAfter: _withCtx(() => [
                _createVNode(_component_AppVerificationCodeBtn, {
                  target: _ctx.$get(_unref(authStore).user, 'profile.phone_number'),
                  event: "verify_phone_number",
                  insert: "half"
                }, null, 8, ["target"])
              ]),
              _: 1
            }, 8, ["config", "form"]),
            _createVNode(_component_AppFormGroupItem, {
              config: {
          label: _unref(t)('PASSWORD'),
          type: 'input',
          inputType: 'password',
          key: 'password',
          required: true,
          placeholder: '',
          triggerPwd: true
        },
              form: _unref(verificationForm),
              onChange: verificationFormItemChange
            }, null, 8, ["config", "form"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_b_button, {
              to: {name: 'mine.memberProfile.edit'},
              pill: "",
              variant: _unref(ColorVariants).outlinePrimary,
              style: {"margin-right":"1.5rem"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Cancel')), 1)
              ]),
              _: 1
            }, 8, ["to", "variant"]),
            _createVNode(_component_b_button, {
              type: "submit",
              pill: "",
              variant: _unref(ColorVariants).primary
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Confirm')), 1)
              ]),
              _: 1
            }, 8, ["variant"])
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_b_form, {
        key: 1,
        class: "form-wrapper",
        onSubmit: handleSubmitAnswer
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(t)('Delete Terracycle Account')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(answerFormItems), (item, index) => {
              return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
                key: index,
                config: {
          label: item.label,
          type: item.type,
          key: String(item.keyForSpecifySurvey),
          required: item.required,
          options: item.options,
        },
                form: _unref(answerForm),
                onChange: formItemChange
              }, null, 8, ["config", "form"]))
            }), 128))
          ]),
          _createElementVNode("section", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_9, " 사용하고 계신 테라사이클 계정(" + _toDisplayString(_unref(authStore).user.screen_name) + ")은 탈퇴할 경우 복구가 불가능합니다. ", 1),
              _hoisted_10
            ]),
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_b_button, {
              to: {name: 'mine.memberProfile.edit'},
              pill: "",
              variant: _unref(ColorVariants).outlinePrimary,
              style: {"margin-right":"1.5rem"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Cancel')), 1)
              ]),
              _: 1
            }, 8, ["to", "variant"]),
            _createVNode(_component_b_button, {
              type: "submit",
              pill: "",
              variant: _unref(ColorVariants).primary
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Confirm')), 1)
              ]),
              _: 1
            }, 8, ["variant"])
          ])
        ]),
        _: 1
      }))
}
}

})